import type {TableConfiguration} from '../types';

export const defaultTableConfig: TableConfiguration = {
  /*
    If nothing is defined with schema specific defaults, defaultColumns will be
    automatically populated with parts from schema.
   */
  defaultColumns: [],
  disableSorting: false,
  disableFiltering: true, // Plan to change this to false in the future.
  disableFilteringByName: {},
  disableColumnResize: false,
  autoRowHeight: true,
  enableQuickFilter: false,
  hideFooter: true,
  pageSizeAllowAll: false,
};
